import { configureStore, createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { GameState, MultiplierValue } from '../types/enums';
import type { GameStore } from '../types/schema';

const initialState: GameStore = {
  coins: 3,
  gameState: GameState.IDLE,
  currentMultiplier: null,
  soundEnabled: true
};

const gameSlice = createSlice({
  name: 'game',
  initialState,
  reducers: {
    decrementCoins: (state) => {
      if (state.coins > 0) {
        state.coins -= 1;
      }
    },
    setGameState: (state, action: PayloadAction<GameState>) => {
      state.gameState = action.payload;
    },
    setCurrentMultiplier: (state, action: PayloadAction<MultiplierValue | null>) => {
      state.currentMultiplier = action.payload;
    },
    toggleSound: (state) => {
      state.soundEnabled = !state.soundEnabled;
    },
    resetGame: (state) => {
      state.coins = 3;
      state.gameState = GameState.IDLE;
      state.currentMultiplier = null;
    }
  }
});

export const { decrementCoins, setGameState, setCurrentMultiplier, toggleSound, resetGame } = gameSlice.actions;

export const store = configureStore({
  reducer: {
    game: gameSlice.reducer
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;